/**
 * Featured Collection Swiper initialization
 */
(() => {
  console.log('Featured Collection JS loaded');
  
  /**
   * Actualiza la visibilidad de las flechas de navegación
   * Solo muestra las flechas si hay más slides que los visibles
   */
  function updateNavigationVisibility(swiper, sectionId, config) {
    // Verificar si hay una navegación específica para esta sección
    const prevBtn = document.querySelector(`.featured-collection__nav-button--prev[data-section="${sectionId}"]`);
    const nextBtn = document.querySelector(`.featured-collection__nav-button--next[data-section="${sectionId}"]`);
    
    if (!prevBtn || !nextBtn) return;
    
    // Encontrar el contenedor padre que contiene ambos botones
    const navigationWrapper = prevBtn.closest('.featured-collection__navigation');
    if (!navigationWrapper) return;
    
    // Obtener la cantidad de slides
    const totalSlides = swiper.slides.length;
    
    // Obtener el ancho de ventana actual
    const windowWidth = window.innerWidth;
    
    // Determinar las columnas según el breakpoint actual basado en la configuración
    let slidesPerView;
    if (windowWidth >= 990) {
      // Desktop
      slidesPerView = parseFloat(config.desktopColumns) || 4;
    } else if (windowWidth >= 750) {
      // Tablet
      slidesPerView = parseFloat(config.tabletColumns) || 3;
    } else {
      // Mobile
      slidesPerView = parseFloat(config.mobileColumns) || 1.2;
    }
    
    // Redondear hacia abajo para comparación
    slidesPerView = Math.floor(slidesPerView);
    
    // Debug
    console.log(`Section: ${sectionId}`);
    console.log(`Window width: ${windowWidth}px`);
    console.log(`Total slides: ${totalSlides}`);
    console.log(`Slides per view (configured): ${slidesPerView}`);
    console.log(`Config:`, config);
    
    // Determinar si necesita navegación
    const needsNavigation = totalSlides > slidesPerView;
    
    console.log(`Needs navigation: ${needsNavigation}`);
    console.log('---');
    
    // Agregar o remover clase CSS
    if (needsNavigation) {
      navigationWrapper.classList.remove('featured-collection__navigation--hidden');
      navigationWrapper.setAttribute('data-navigation-needed', 'true');
    } else {
      navigationWrapper.classList.add('featured-collection__navigation--hidden');
      navigationWrapper.setAttribute('data-navigation-needed', 'false');
    }
  }

  function initFeaturedCollectionSwiper() {
    const swiperContainers = document.querySelectorAll('.featured-collection__swiper[data-swiper-config]');
    console.log(`Found ${swiperContainers.length} swiper containers`);

    swiperContainers.forEach((container) => {
      if (container.swiper) return; // Already initialized

      const config = JSON.parse(container.dataset.swiperConfig || '{}');
      const sectionId = container.dataset.sectionId || '';
      
      console.log(`Initializing swiper for section: ${sectionId}`);

      const swiperOptions = {
        slidesPerView: config.mobileColumns || 1.2,
        spaceBetween: config.spaceBetween || 16,
        grabCursor: true,
        watchOverflow: true,
        navigation: {
          prevEl: `.featured-collection__nav-button--prev[data-section="${sectionId}"]`,
          nextEl: `.featured-collection__nav-button--next[data-section="${sectionId}"]`,
        },
        pagination: config.showPagination ? {
          el: `.featured-collection__pagination[data-section="${sectionId}"]`,
          clickable: true,
        } : false,
        autoplay: config.autoRotate && config.autoRotate !== 'disabled' ? {
          delay: parseInt(config.autoRotate, 10) * 1000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        } : false,
        breakpoints: {
          750: {
            slidesPerView: config.tabletColumns || 3,
            spaceBetween: config.spaceBetween || 20,
          },
          990: {
            slidesPerView: config.desktopColumns || 4,
            spaceBetween: config.spaceBetween || 24,
          },
        },
        on: {
          init: function(swiper) {
            updateNavigationVisibility(swiper, sectionId, config);
          },
          resize: function(swiper) {
            updateNavigationVisibility(swiper, sectionId, config);
          },
          breakpoint: function(swiper) {
            updateNavigationVisibility(swiper, sectionId, config);
          },
          slideChange: function(swiper) {
            updateNavigationVisibility(swiper, sectionId, config);
          }
        }
      };

      new Swiper(container, swiperOptions);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedCollectionSwiper);
  } else {
    initFeaturedCollectionSwiper();
  }

  // Re-initialize on Shopify section events (Theme Editor)
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.featured-collection__swiper')) {
      initFeaturedCollectionSwiper();
    }
  });
})();

